import {
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  SvgIconProps,
} from '@material-ui/core'
import { ReactElement, useRef, useState } from 'react'

interface Option {
  onClick: () => void
  label: string
}

interface Props {
  options: Option[]
  icon: ReactElement<SvgIconProps>
}

const ActionsMenu = ({ options, icon, ...restProps }: Props) => {
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleListKeyDown = (event: any) => {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  return (
    <>
      <IconButton ref={anchorRef} onClick={() => setOpen(true)} {...restProps}>
        {icon}
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 9 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  {options.map((option: Option, index: number) => (
                    <MenuItem
                      key={index}
                      onClick={(e) => {
                        handleClose()
                        option.onClick()
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}

export default ActionsMenu
